import {
  FETCH_BRAND_CATEGORY_DETAILS_BEGIN,
  FETCH_BRAND_CATEGORY_DETAILS_SUCCESS,
  FETCH_BRAND_CATEGORY_DETAILS_FAILURE,
  EXPAND_CATEGORY_DETAILS,
  RESET_BRAND_CATEGORY_DETAILS
} from '../constants/brandCategoryActionTypes';

const initialState = {
  categoryName: '',
  categories: [],
  categoriesExpand: '',
  error: {}
}

export default function (state, action) {
  if (typeof state === 'undefined') {
    state = initialState;
  }
  switch (action.type) {
    case FETCH_BRAND_CATEGORY_DETAILS_BEGIN:
      return {
        ...state,
      };
    case FETCH_BRAND_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        categories: action.payload.result,
        categoriesExpand: action.payload.categoriesExpand
      };
    case FETCH_BRAND_CATEGORY_DETAILS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case EXPAND_CATEGORY_DETAILS:
      return {
        ...state,
        categoriesExpand: state.categoriesExpand === action.payload ? '' : action.payload
      }
  case RESET_BRAND_CATEGORY_DETAILS:
      return {
        ...state,
        categoryName: '',
        categories: [],
        categoriesExpand: ''
      }
    default:
      return state;
  }
}
